import classNames from 'classnames'
import useTranslation from '../hooks/useTranslation'

export const MobileNumberInput = ({
  id,
  countryCode,
  onChange,
  error = false,
  errorMsg,
  mobileNumber,
  disabled = false,
  containerClassName = '',
  inputOnClick = () => {},
  ...props
}) => {
  const translation = useTranslation()

  return (
    <>
      <div
        className={classNames(
          'mt-sm box-border flex h-[40px] items-center rounded-sm border-[1px] border-solid border-[#989898] pt-xs pb-[9px] text-base font-normal leading-16 text-darkGray',
          error && 'border-error',
          disabled && ' bg-[#F2F2F3]',
          containerClassName
        )}
        onClick={() => document?.getElementById(id)?.focus()}
      >
        <div className="border-[0px] border-r-xs border-solid border-xLigthGray pl-sm pr-[11px] pt-[4px] pb-[3px] font-roboto">
          +{countryCode}
        </div>
        <div className="flex-1 pl-[12px]">
          <input
            type="tel"
            tabIndex={'-1'}
            id={id}
            className="remove w-[95%] border-none bg-white p-[0px] pr-[5px] text-base font-normal leading-16 text-darkGray focus:outline-none disabled:border-[0px] disabled:bg-[#F2F2F3]"
            value={mobileNumber}
            pattern="[0-9]"
            disabled={disabled}
            maxLength="10"
            autoComplete="off"
            onClick={inputOnClick}
            onChange={(event) => {
              const value = event?.target?.value
              if (
                (Number(value.trim()) &&
                  !value.includes(' ') &&
                  !value.includes('.') &&
                  !value.includes('-')) ||
                value === '' ||
                (Number(value.trim()) === 0 && !value.includes(' '))
              )
                onChange(event)
            }}
            {...{ ...props }}
          />
        </div>
      </div>
      {error && (
        <div className="my-sm text-sm font-normal leading-16 text-error">
          {errorMsg || translation?.incorrectCredentials}
        </div>
      )}
    </>
  )
}
